import { module } from 'modujs';
import { html } from '../utils/environment'

const CLASS = {
    OPEN: `has-menu-tools-open`,
}

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                closeButton: 'close'
            }
        }
    }

    init(){

    }

    open() {
        html.classList.add(CLASS.OPEN)
    }

    close() {
        html.classList.remove(CLASS.OPEN)
    }

    destroy() {
        
    }
}
